import page from "./Page";
import notices from "./Notices";
import Sliders from "./Sliders";
import Header from "./Header";
import CustomDropdown from "./CustomDropdown";
import FaqAccordion from "./FaqAccordion";
import InstagramRedirect from "./InstagramRedirect";
import { globalToast } from "./GlobalToast";

export default {
  ...page,
  ...notices,
  Sliders,
  Header,
  CustomDropdown,
  FaqAccordion,
  InstagramRedirect,
  globalToast,
};
